import { useAuth } from '../../context/AuthContext';
import { btn, c } from '../../theme';

// Which department's floor a page is showing. Only the departments this
// person holds that carry the page are offered, from the session's own
// summary (/auth/me), so the list never claims access the server would
// refuse. One department means no switcher: a Collections supervisor should
// not be asked which floor they are on.
//
// Support comes first where it is held, because these pages were Support's
// before there were departments.

export function ccDepartments(user, view) {
  const held = user?.contactCenter?.departments || [];
  return held.filter((d) => d.views?.includes(view))
    .sort((a, b) => (a.id === 'support' ? -1 : b.id === 'support' ? 1 : String(a.label).localeCompare(String(b.label))));
}

export default function DeptSwitcher({ view, value, onChange }) {
  const { user } = useAuth();
  const departments = ccDepartments(user, view);
  if (departments.length < 2) return null;
  return (
    <div style={s.row} role="group" aria-label="Department">
      <span style={s.label}>Dept</span>
      {departments.map((d) => (
        <button key={d.id} type="button" aria-pressed={value === d.id} onClick={() => onChange(d.id)}
          style={value === d.id ? s.on : s.off}>{d.label}</button>
      ))}
    </div>
  );
}

const s = {
  row:   { display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap' },
  label: { fontSize: '10px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: c.textMuted },
  off:   { ...btn.secondaryXs },
  on:    { ...btn.secondaryXs, background: c.navy, color: '#fff', borderColor: c.navy },
};
